export default "__VITE_ASSET__Di88piST__"